export default __webpack_public_path__ + "static/media/FFDF4892-F07B-4BE2-A766-383723A99379_1_105_c.f5ee83d7.jpeg";